import React, { ReactElement } from 'react';
import { observer } from 'src/utils/mobx-react';
import Header from 'src/components/Header';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';

import { useAppStateContext } from 'src/AppState/AppState';
import { MenuItemsType } from 'src/components/Header/LHSMenu/SideMenu/SideMenu';
import CustomersBar from 'src/components/CustomersBar';

import { Events } from 'src/domains/sportsbook/trading/view/eventDetails/Events';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { TradingContent } from 'src/layouts/TradingPage/TradingContent';

import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import { PepXmlRouterWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import Audits from 'src/components/Audits';

export const TradingPageV2 = observer('TradingPageV2', (): ReactElement => {
    const { routerBackoffice } = useAppStateContext();

    const menuItems: Array<MenuItemsType> = [
        {
            id: 'events',
            label: 'Events',
            onClick: (): void => {},
        },
        {
            id: 'liabilities',
            label: 'Liabilities',
            onClick: (): void => {},
        },
        {
            id: 'bet-search',
            label: 'Bet search',
            onClick: (): void => {},
        },
        {
            id: 'payment-searchV2',
            label: 'Payment search',
            onClick: (): void => routerBackoffice.redirectToTradingPaymentSearchV2(),
        },
        {
            id: 'csv-uploadV2',
            label: 'CSV upload',
            onClick: (): void => routerBackoffice.redirectToTradingCsvUploadV2(),
        },
    ];

    return (
        <LayoutWrapper>
            <MainContainer className='bg-muted'>
                <Header sideLinks={menuItems} />
                <TradingContent />
            </MainContainer>
            <CustomersBar />

            <EventsTrigger />
            <Events />
            <Audits />
            <ComplianceAudits />
            <PepXmlRouterWrapper />
        </LayoutWrapper>
    );
});
